import loaded from '@/scripts/helpers/loaded';

loaded(() =>{
    document.querySelectorAll('.js--hover--play--video').forEach(function(element) {
        element.addEventListener('mouseenter', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.play();
            }
        });
        
        element.addEventListener('mouseleave', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.pause();
            }
        });
    });
});
